var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9976 49.9951C99.9976 77.6057 77.6142 99.9899 49.9988 99.9899C22.3834 99.9899 0 77.6057 0 49.9951C0 22.3845 22.3839 0 49.9988 0C77.6137 0 99.9976 22.3823 99.9976 49.9951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9974 0C22.3919 0 -0.0311954 22.4161 0.0039475 49.9935C0.0108696 55.5109 0.890774 60.8182 2.54222 65.7827H17.5014V23.7256L49.9974 56.2179L82.4918 23.7256V65.7835H97.4542C99.1081 60.8193 99.9834 55.5119 99.9933 49.9943C100.04 22.3882 77.6059 0.00665515 49.9974 0.00665515V0Z",
    fill: "#F26822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5245 63.6876L28.343 49.5068V75.9714H17.5006L7.26953 75.9733C16.0454 90.3697 31.9055 100 49.9977 100C68.0899 100 83.9509 90.3676 92.7283 75.9712H71.6492V49.5068L57.4669 63.6876L49.9961 71.1576L42.5251 63.6876H42.5245Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmr);
export default __webpack_public_path__ + "static/media/XMR.62c88c61b2f34fa5ba7098337581e51d.svg";
export { ForwardRef as ReactComponent };